import {inject} from '@angular/core';
import {CanActivateFn, RedirectCommand, Router} from '@angular/router';
import {SystemInfoService} from '../services/system-info/system-info.service';

/**
 * Guards the `unsupported-browser` page so only genuinely unsupported web browsers can stay on it.
 *
 * Mirrors the redirect condition in `appInitializerFactory`: the page is meant exclusively for
 * unsupported web browsers. A supported browser (e.g. after a browser update, a bookmarked or
 * shared link) or any non-web platform is sent back to the home page so nobody gets stuck here.
 */
export const isUnsupportedBrowserRouteGuard: CanActivateFn = (): boolean | RedirectCommand => {
    const systemInfoService: SystemInfoService = inject(SystemInfoService);
    const router: Router = inject(Router);

    if (systemInfoService.isWebApp() && !systemInfoService.isSupportedBrowser()) {
        return true;
    }

    return new RedirectCommand(router.parseUrl('/'));
};
